import { API_BASE_URL } from '../config/api';
import { throwForCreditGate } from './entitlementErrors';

// Interface for the API response
export interface AudioGenerationResponse {
  message: string;
  result: {
    audioFile: string;
    audioLengthInSeconds: number;
  };
}

/**
 * Generates audio from text using the selected voice via the backend API
 * @param text Text to convert to speech
 * @param voiceId ID of the voice to use
 * @returns Promise with the audio URL and duration
 */
export const generateAudioFromAPI = async (
  text: string,
  voiceId: string,
  style: string
): Promise<AudioGenerationResponse> => {
  const token = localStorage.getItem('authToken');
  console.log(text, voiceId, style);
  try {
    const response = await fetch(`${API_BASE_URL}/generate/voice`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-request-id': '123',
        Accept: 'text/event-stream',
      },
      body: JSON.stringify({
        text,
        voiceId,
        style,
      }),
    });

    if (!response.ok) {
      const errorData = await response.text().catch(() => '');
      // 402/403 throw the shared typed errors (same upsell handling as video).
      throwForCreditGate(response.status, errorData, {
        insufficient: 'Insufficient pixles for this voiceover',
        noEntitlement: 'An active subscription is required for this voiceover',
        failed: `Failed to generate audio: ${response.status}`,
      });
    }

    const data: AudioGenerationResponse = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error('Error generating audio from API:', error);
    throw error;
  }
};

/**
 * Fetches the audio file from the provided URL
 * @param audioUrl URL of the audio file
 * @returns Promise with the audio blob
 */
export const fetchAudioFile = async (audioUrl: string): Promise<Blob> => {
  try {
    const response = await fetch(audioUrl);

    if (!response.ok) {
      throw new Error(`Failed to fetch audio file: ${response.status}`);
    }

    return await response.blob();
  } catch (error) {
    console.error('Error fetching audio file:', error);
    throw error;
  }
};
